const translations = {
  "en": {
    "Portfolio": "Portfolio",
    "Watchlist": "Watchlist"
  },
  "zh-tw": {
    "Portfolio": "投資組合",
    "Watchlist": "監視清單"
  }
};

export default translations;
